import { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { NavItemDataProps, NavMenuProps } from '../../types';
import useClickOutside from '../../hooks/useClickOutside';
import { DashboardContext } from '../../context/DashboardContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLocation } from 'react-router-dom';
import { Badge } from '@mui/material';

export default function NavMenu({ items, open, level = 0 }: NavMenuProps) {
    const location = useLocation();
    const context = useContext(DashboardContext)
    const [indexOpen, setIndexOpen] = useState(-1)
    const menuRef = useRef(null)
    const onAction = useCallback((item: NavItemDataProps, index: number, e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        e.preventDefault()
        if (item.items) {
            setIndexOpen(index === indexOpen && context?.navBar.expanded ? -1 : index)
            context?.setNavBar({ ...context.navBar, parentOpen: true })
        } else {
            item.path && context?.onPath(item)
            context?.setNavBar({
                ...context.navBar,
                parentOpen: context.navBar.expanded ? context.navBar.parentOpen : false,
                openResponsiveMenu: false,
                menuSelected: item
            })
            item.action && item.action()
        }
    }, [context])
    useClickOutside(menuRef, () => {
        if (level === 0 && !context?.navBar.expanded) {
            setIndexOpen(-1)
        }
    })

    useEffect(() => {
        if (!open) {
            setIndexOpen(-1)
        }
    }, [open])

    useEffect(() => {
        if(location.pathname !== context?.navBar.menuSelected?.path){
            let itemInView = items.find(i => decodeURI(location.pathname).endsWith(i.path || i.label))
            if (itemInView) {
                context?.setNavBar({
                    ...context.navBar,
                    menuSelected: itemInView
                })
            }
        }
    }, [location.pathname])

    return <ul className={`nav-menu ${open && 'open'} ${level > 0 && 'submenu'} `} ref={menuRef}>
        {items.map((item, idx) => <li
            key={item.label}
            aria-level={level}
            className={`nav-menu-item ${`nav-menu-item-${level}`} ${indexOpen === idx && 'open'}`}
            title={context?.navBar.expanded ? '' : item.label}
        >
            {item.disabled ? <label className={`nav-body  ${`nav-body-${level}`} ${item.disabled && 'disabled'} d-flex-center`}>
                {item.icon && <FontAwesomeIcon icon={item.icon} className='nav-body-icon' />}
                <span className='nav-body-label'>{item.label}</span>
            </label> : <>
                <a href={item.path || '#'}
                    className={`nav-body ${`nav-body-${level}`} ${indexOpen === idx && 'open'} ${location.pathname.includes(item?.path || item.label) && 'current'}  d-flex-center`}
                    onClick={(e) => onAction(item, idx, e)}
                >
                    {item.icon && (context?.navBar.expanded || !item.decorator ? <FontAwesomeIcon icon={item.icon} className='nav-body-icon' /> : <Badge
                        badgeContent={item.decorator.value}
                        color="secondary"
                    >
                        <FontAwesomeIcon icon={item.icon} 
                        className='nav-body-icon' />
                    </Badge>)}
                    <span className='nav-body-label'>{item.label}</span>
                    {item.items && <FontAwesomeIcon
                        icon="chevron-down"
                        className={`nav-body-arrow ${indexOpen === idx && 'open'}`}
                    />}

                    {item.decorator && item.decorator.value > 0 && context?.navBar.expanded && <Badge
                        badgeContent={item.decorator.value}
                        color="secondary"
                        sx={{ marginRight: '0.5rem' }}
                    >
                        <FontAwesomeIcon icon={item.decorator.icon} />
                    </Badge>}
                </a>
                {item.items && <NavMenu items={item.items || []} level={level + 1} open={indexOpen === idx} />}
            </>}
        </li>)}
    </ul>
}
